import React, { FC, memo } from 'react';
import { createSelectRequestPendingSelector } from 'scenes/App';
import { selectPreferencesStatus } from '../../preferencesSelectors';
import { GlobalUnsubscribeButton } from './components/GlobalUnsubscribeButton';
import { Inline, Text } from '@atlaskit/primitives';
import { useAppSelector } from '../../../../hooks';
import { PREFERENCES_LOAD_USER_PREFIX } from '../../constants';

interface OwnProps {
  email: string | undefined;
  onUnsubscribeClick?: () => void;
}

const ActionsBar: FC<OwnProps> = ({ email, onUnsubscribeClick }) => {
  const status = useAppSelector(selectPreferencesStatus);
  const isPending = useAppSelector(createSelectRequestPendingSelector([PREFERENCES_LOAD_USER_PREFIX]));

  if (isPending || email == null) return null;

  const statusNotOk = status.status !== 'ok';

  return (
    <Inline testId='actions-bar' space='space.150' alignBlock='center'>
      <GlobalUnsubscribeButton isDisabled={statusNotOk} onClick={onUnsubscribeClick} />
      <Text maxLines={1} color={'color.text.subtlest'}>
        {email}
      </Text>
    </Inline>
  );
};

export default memo(ActionsBar);
